export default __webpack_public_path__ + "static/media/proj1.2efc2108.png";